<div class="position-relative d-flex flex-column" appDrag>
  <div *ngIf="!fileUrl">
    <div class="select-field">
      <button (click)="fileInput.value='';fileInput.click()" class="cursor select-file">
        Select File
      </button>
    </div>
    <div *ngIf="pageType === 'template-management'" class="upload-note">{{ fileSizeLimit?.errorMessage }}, Support File Type: csv</div>
    <div *ngIf="pageType === 'add-batch'" class="upload-note">{{ fileSizeLimit?.errorMessage }}, Support File Type: csv</div>
    <div *ngIf="pageType === 'add-device'" class="upload-note">{{ fileSizeLimit?.errorMessage }}, Support File Type: csv</div>
  </div>

  <div *ngIf="fileUrl" class="select-field-wrapper d-flex cursor file-selected "
    [ngClass]="{'kb-thumbnail-bg-fill-uploaded': uploadedFileUrl,'kb-thumbnail-bg-fill': !uploadedFileUrl,
      'select-field-wrapper-template': pageType==='template-management' || pageType==='add-device','select-field-wrapper': pageType!=='template-management' &&  pageType!=='add-device'}">
    <img src="../../../../assets/images/file.svg" *ngIf="fileName && !uploadedFileUrl" alt="delete"
      class="cursor h-30 file-img">
    <img src="../../../../assets/images/file-white.svg" *ngIf="fileName && uploadedFileUrl" alt="delete"
      class="cursor h-30 file-img">
    <span class="ellipsis">{{ fileName }}</span>
    <img src="../../../../assets/images/upload.svg"
      *ngIf="pageType==='template-management' && fileName && fileType === 'text/csv' && fileSize < fileSizeLimit?.fileSize && !uploadedFileUrl" (click)="onUpload()" alt="Info"
      class="cursor h-30 ml-2">
      <img src="../../../../assets/images/upload.svg"
      *ngIf="pageType === 'add-batch' && fileName && fileType === 'text/csv' && fileSize < fileSizeLimit?.fileSize && !uploadedFileUrl" (click)="onUpload()" alt="Info"
      class="cursor h-30 ml-2">
      <img src="../../../../assets/images/upload.svg"
      *ngIf="pageType === 'add-device' && fileName && fileType === 'text/csv' && fileSize < fileSizeLimit?.fileSize && !uploadedFileUrl && headerValid" (click)="onUpload()" alt="Info"
      class="cursor h-30 ml-2">
    &nbsp;&nbsp;<img src="../../../../assets/images/delete.svg" *ngIf="fileName && !uploadedFileUrl" alt="delete"
      class="cursor h-30" (click)="onSoftDelete();$event.stopPropagation();">
    &nbsp;&nbsp;<img src="../../../../assets/images/delete-white.svg" *ngIf="fileName && uploadedFileUrl" alt="delete"
      class="cursor h-30" (click)="onSoftDelete();$event.stopPropagation();">
  </div>
  <input #fileInput class="file" type="file" accept="{{ requiredFileType?.join(', ') }}">
</div>